<template>
  <a-card title="Tạo mới quy trình" class="root-card">
    <a-form-model layout="horizontal" v-bind="{labelCol: { span: 2 },wrapperCol: { span: 20 },}">
      <a-form-model-item label="Tiêu đề">
        <a-input placeholder="Tiêu đề" v-model="formData.createProcedure.title" />
      </a-form-model-item>
      <a-form-model-item label="Mô tả">
        <a-textarea placeholder="Mô tả" v-model="formData.createProcedure.description" :auto-size="{ minRows: 4, maxRows: 8 }"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 20, offset: 2 }">
        <a-table
          id="scripts-table"
          :columns="tables.scriptsTable.columns"
          :data-source="tables.scriptsTable.dataSource"
          :loading="loading.scriptsTable"
          :scroll="{ y: 350 }"
          :pagination="false"
        bordered>
          <div style="white-space: pre-wrap" slot="description" slot-scope="description" v-html="description"></div>
          <template slot="configurations" slot-scope="configurations">
            <a-icon v-if="validConfigurations(configurations)" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          </template>
          <template slot="operation" slot-scope="text, record, index">
            <a href="javascript:;" @click="openConfigScriptModal(index, record.configurations)"><a-icon type="control" /> Cấu hình</a>
            <a-popconfirm
              style="margin-left: 15px"
              v-if="tables.scriptsTable.dataSource.length"
              title="Bạn có chắc muốn xóa kịch bản này?"
              @confirm="() => removeScriptFromProcedure(index)"
            >
              <a href="javascript:;" style="color: red"><a-icon type="delete" /> Xóa</a>
            </a-popconfirm>
            <a-icon v-if="index > 0" style="margin-left: 15px; font-size: 18px; color: #2d7329;" type="arrow-up" @click="moveScriptUp(index)" />
            <a-icon v-if="index < (tables.scriptsTable.dataSource.length - 1)" style="margin-left: 15px; font-size: 18px; color: blueviolet;" type="arrow-down" @click="moveScriptDown(index)" />
          </template>
        </a-table>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 20, offset: 2 }">
        <a-button type="default" @click="() => visible.chooseScriptModal = true"><a-icon type="plus-circle" /> Thêm kịch bản</a-button>
        <a-button type="primary" :loading="loading.createProcedure" @click="handleCreateProcedure" style="margin-left: 15px"><a-icon type="save" /> Tạo mới</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-modal id="scripts-modal" width="1200px" v-model="visible.chooseScriptModal" title="Danh sách kịch bản" @ok="() => visible.chooseScriptModal = false">
      <div class="card-container">
        <div class="card" v-for="(script, index) in scripts" :key="index">
          <a-card hoverable>
            <template slot="actions">
              <a-icon key="add" type="plus" @click="addScript(script)" />
            </template>
            <a-card-meta style="height: 115px; white-space: pre-wrap;text-overflow: ellipsis;overflow: hidden;" :title="script.name">
              <div slot="description" v-html="script.description"></div>
            </a-card-meta>
          </a-card>
        </div>
      </div>
    </a-modal>
    <a-modal 
      id="script-config-modal" 
      width="1000px" 
      v-model="visible.scriptConfigModal" 
      :title="`Cài đặt kịch bản - ${selectedConfigScript?.name || ''}`"
      @ok="saveScriptConfig"
      >
      <div v-if="selectedConfigScript">
        <a-table
          id="scripts-config-table"
          :columns="tables.configScriptTable.columns"
          :data-source="selectedConfigScript.configurations"
          :loading="loading.configScriptTable"
          :scroll="{ y: 350 }"
          :pagination="false"
        bordered>
          <div style="white-space: pre-wrap;" slot="description" slot-scope="description">{{description}}</div>
          <template slot="required" slot-scope="required">
            <a-icon v-if="required" type="check-circle" theme="twoTone" twoToneColor="#52c41a" />
          </template>
          <template slot="selectValue" slot-scope="text, record">
            <a-input 
              v-if="!record.options && !record.tag_index" 
              :value="record.value !== undefined ? record.value.toString() : record?.default_value?.toString()"
              @change="handleChangeScriptConfigInputValue(record.key, $event)"
              >
            </a-input>
            <a-select 
              style="width: 100%" 
              v-else-if="record.options && record.options.length > 0 && !record.tag_index" 
              :value="record.value !== undefined ? record.value.toString() : record?.default_value?.toString()"
              @change="handleChangeScriptConfigSelectValue(record.key, $event)"
              :allowClear="true"
              >
              <a-select-option v-for="option in record.options" :key="option.value?.toString()" :value="option.value?.toString()">{{option.title?.toString()}}</a-select-option>
            </a-select>
            <a-select 
              style="width: 100%" 
              v-else-if="!!record.tag_index" 
              :value="record.value !== undefined ? record.value.toString() : record?.default_value?.toString()"
              @change="handleChangeScriptConfigSelectValue(record.key, $event)"
              :allowClear="true"
              >
              <a-select-option v-for="tag in tags[record.tag_index] || []" :key="tag.id" :value="tag.id">
                <a-tag>{{tag.title}}</a-tag>
              </a-select-option>
            </a-select>
          </template>
        </a-table>
      </div>
    </a-modal>
  </a-card>
</template>
<style scoped>
#scripts-modal .card-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 16px;
}

#scripts-modal .card {
  margin-bottom: 16px;
}
</style>
<script>
import {mapActions, mapGetters} from 'vuex';

const configScriptTableColumns = [
  {
    title: 'Tiêu đề',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: 'Mô tả',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: 'Bắt buộc',
    dataIndex: 'required',
    key: 'required',
    width: '100px',
    align: 'center',
    scopedSlots: { customRender: 'required' }
  },
  {
    title: 'Cài đặt',
    scopedSlots: { customRender: 'selectValue' },
  }
];

const scriptsTableColumns = [
  {
    title: 'Tên kịch bản',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: 'Mô tả',
    dataIndex: 'description',
    key: 'description',
    scopedSlots: { customRender: 'description' }
  },
  {
    title: 'Đã cấu hình',
    dataIndex: 'configurations',
    key: 'configurations',
    width: '110px',
    align: 'center',
    scopedSlots: { customRender: 'configurations' }
  },
  {
    title: 'Thao tác',
    scopedSlots: { customRender: 'operation' },
  }
];

export default {
  data() {
    return {
      tables: {
        scriptsTable: {
          columns: scriptsTableColumns,
          dataSource: []
        },
        configScriptTable: {
          columns: configScriptTableColumns,
          dataSource: []
        }
      },
      loading: {
        scriptsTable: false,
        configScriptTable: false,
        createProcedure: false
      },
      visible: {
        chooseScriptModal: false,
        scriptConfigModal: false
      },
      selected: {
        scriptConfigIndex: undefined
      },
      formData: {
        createProcedure: {
          title: undefined,
          description: undefined
        }
      },
      tags: {

      }
    }
  },
  mounted() {
    this.fetchScripts();
  },
  computed: {
    ...mapGetters('procedure', {
      scripts: "getScripts"
    }),

    selectedConfigScript() {
      const index = this.selected.scriptConfigIndex;

      if (index > -1) {
        return this.tables.scriptsTable.dataSource[index];
      }

      return undefined;
    }
  },
  methods: {
    ...mapActions('procedure', {
      fetchScripts: "fetchScripts",
      createProcedure: "createProcedure"
    }),

    ...mapActions("tag", {
      fetchTags: "fetchTags"
    }),

    validConfigurations(configurations) {
      const requiredConfigs = (configurations && configurations.length > 0) ?configurations?.filter(config => config.required) : [];
      let valid = true;

      for (let i=0; i<requiredConfigs.length; i++) {
        const {value} = requiredConfigs[i];

        if (value == undefined || value == null || value == '') {
          valid = false;
        }
      }

      return valid;
    },

    removeScriptFromProcedure(index) {
      if (this.tables.scriptsTable.dataSource[index]) {
        this.tables.scriptsTable.dataSource.splice(index, 1);
        this.$message.success('Deleted!');
      }
    },

    async openConfigScriptModal(index, configurations) {
      const hasTagIndexConfigs = configurations?.filter(config => {
        return !!config?.tag_index;
      });
      const tagIndexSet = new Set();

      hasTagIndexConfigs.forEach(config => {
        tagIndexSet.add(config.tag_index);
      });

      const tagIndexs = Array.from(tagIndexSet);

      if (tagIndexs && tagIndexs.length > 0) {
        const promises = tagIndexs.map(index => {
          if (this.tags[index]) {
            return null;
          }

          return this.fetchTags({
            index: index
          });
        })
        
        const tagsOfIndexs = await Promise.all(promises);

        tagsOfIndexs.forEach((tags, index) => {
          if (tags && tags?.length > 0) {
            this.tags[tagIndexs[index]] = tags;
          }
        });
      }

      this.selected.scriptConfigIndex = index;
      this.visible.scriptConfigModal = true;
    },

    handleChangeScriptConfigSelectValue(key, value) {
      const configurations = this.tables.scriptsTable.dataSource[this.selected.scriptConfigIndex].configurations;
      const index = configurations.findIndex(config => config.key == key);

      if (index > -1) {
        this.$set(this.tables.scriptsTable.dataSource[this.selected.scriptConfigIndex].configurations[index], 'value', value);
      }
    },

    handleChangeScriptConfigInputValue(key, event) {
      const value = event?.target?.value;
      const configurations = this.tables.scriptsTable.dataSource[this.selected.scriptConfigIndex].configurations;
      const index = configurations.findIndex(config => config.key == key);

      if (index > -1) {
        this.$set(this.tables.scriptsTable.dataSource[this.selected.scriptConfigIndex].configurations[index], 'value', value);
      }
    },

    addScript(script) {
      const copiedScript = JSON.parse(JSON.stringify(script));
      this.tables.scriptsTable.dataSource.push(copiedScript);
      this.$message.success(`Thêm script ${script.name} thành công!`);
    },

    saveScriptConfig() {
      this.visible.scriptConfigModal = false;
      this.$message.success(`Cấu hình kịch bản ${this.selectedConfigScript.name} thành công!`);
    },

    async handleCreateProcedure() {
      this.loading.createProcedure = true;
      try {
        await this.createProcedure({
          title: this.formData.createProcedure.title,
          description: this.formData.createProcedure.description,
          steps: this.tables.scriptsTable.dataSource.map(script => {
            return {
              script_code: script.code,
              configurations: script.configurations.map(config => {
                return {
                  key: config.key,
                  value: config.value
                }
              })
            }
          })
        });
        this.$message.success('Tạo mới procedure thành công!');
        this.$router.push({name: 'ListProcedure'});
      }
      catch(error) {
        this.$message.error(error?.response?.data?.error?.message || error?.response?.data || error?.message);
      }
      this.loading.createProcedure = false;
    },

    moveScriptUp(index) {
      if (index > 0) {
        const top = this.tables.scriptsTable.dataSource[index - 1];
        this.tables.scriptsTable.dataSource[index - 1] = this.tables.scriptsTable.dataSource[index];
        this.tables.scriptsTable.dataSource[index] = top;
        this.$forceUpdate();
      }
    },

    moveScriptDown(index) {
      if (index < (this.tables.scriptsTable.dataSource.length - 1)) {
        const bottom = this.tables.scriptsTable.dataSource[index + 1];
        this.tables.scriptsTable.dataSource[index + 1] = this.tables.scriptsTable.dataSource[index];
        this.tables.scriptsTable.dataSource[index] = bottom;
        this.$forceUpdate();
      }
    }
  }
};
</script>
